// extracted by mini-css-extract-plugin
export default {"product":"Product_product__UxOR6","spacer":"Product_spacer__dHmap","descriptionContainer":"Product_descriptionContainer__nH9cY","price":"Product_price__q11pF"};